import { Box, BoxProps, ColorOptions, IconNew as Icon } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC } from 'react'
import NavItem from '../../comps/NavItem'
import { footerStrings, staticStrings } from '../../static/staticStrings'
import { colors } from '../../util/colors'

interface NavMobileProps {
  onPress: () => void
}

export const SideMenu: FC<NavMobileProps> = ({ onPress }: NavMobileProps) => {
  const navigate = useNavigation().navigate
  const themedStyle = styles

  const handleRouting = (id: string): void => {
    onPress()
    navigate(id)
  }

  return (
    <Box {...themedStyle.navbar}>
      <Box {...themedStyle.cancel}>
        <Box
          {...themedStyle.arrowRight}
          onPress={onPress}
          backgroundColor={'#1B3CB014' as ColorOptions}
          underlayColor={'TRANSPARENT'}>
          <Icon id={'CLOSE'} size={16} color={colors.JIO_PRIMARY_ALPHA as ColorOptions} />
        </Box>
      </Box>
      <NavItem
        id="contact"
        title={staticStrings.contact}
        onPress={handleRouting}
        showSeperator={false}
        color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
      />
      <NavItem
        id="about-us"
        title={footerStrings.about}
        onPress={handleRouting}
        showSeperator={false}
        color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
      />
      <NavItem
        id="jiopay"
        title={staticStrings.forBusiness}
        onPress={handleRouting}
        showSeperator={false}
        color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
      />
    </Box>
  )
}

const styles = {
  navbar: {
    display: 'flex',
    flexDirection: 'column',
    // minWidth: 325,
    width: '90vw',
    minHeight: '100vh',
    backgroundColor: 'WHITE',
  } as BoxProps,
  cancel: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: 24,
  } as BoxProps,
  arrowRight: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'WHITE',
    borderRadius: 16,
    height: 32,
    width: 32,
    // Todo
    boxShadow: '0px 10px 20px #E0E0E0',
  } as BoxProps,
}
